"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Events = require("../../util/dom-helpers/events");
function addEventListener(node, event, handler) {
    Events.on(node, event, handler);
    return {
        remove: function () {
            Events.off(node, event, handler);
        }
    };
}
exports.addEventListener = addEventListener;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/react-overlays/utils/add-event-listener.js
// module id = 128
// module chunks = 0 1 2 3 4 5 6